export var logic = {
    result: 'physic',
};
